import { useEffect, useState } from 'react';

export function LandingLogo({
  city,
  dateRange,
}: {
  city: string;
  dateRange: string;
}) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const id = requestAnimationFrame(() => setMounted(true));
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <div
      className="pointer-events-none absolute top-[6%] left-1/2 z-50 flex w-[85vw] max-w-[820px] flex-col items-center gap-3 sm:w-[55vw]"
      style={{
        opacity: mounted ? 1 : 0,
        transform: `translateX(-50%) translateY(${mounted ? 0 : -56}px) scale(${mounted ? 1 : 0.92})`,
        transition:
          'opacity 900ms ease-out 40ms, transform 1100ms cubic-bezier(0.22, 1, 0.36, 1) 40ms',
      }}
    >
      <img
        src="/hack-26/landing/ph26-logo.png"
        alt="Platanus Hack 26"
        width={1153}
        height={248}
        className="h-auto w-full select-none"
      />
      {/* next/font/local over the same AeonikMono-Bold.otf; here it is the 700 weight of
          the `Aeonik Mono` family fonts.css already declares (PORTING.md U7). */}
      <div className="font-aeonik-mono-bold flex flex-col items-center gap-1 text-center text-sm text-white tracking-[0.4em] sm:flex-row sm:gap-4 sm:text-base md:text-lg">
        <span>{city}</span>
        <span className="hidden text-white/50 sm:inline">·</span>
        <span>{dateRange}</span>
      </div>
    </div>
  );
}
